const record = (href, label, icon) => ({ href, label, icon });
export const NAV = {
    operator: {
        label: 'Operator',
        home: '02-dashboard',
        items: [
            record('02-dashboard', 'Dashboard', 'gauge'),
            record('03-tenants', 'Schools', 'building'),
            record('05-onboard', 'Onboard', 'plus'),
            record('06-plans', 'Plans', 'card'),
            record('07-relay', 'Relay fleet', 'server'),
            record('08-agents', 'Agents', 'activity'),
            record('09-analytics', 'Egress & cost', 'gauge'),
            record('10-audit', 'Audit', 'shield'),
            record('12-vendors', 'RTSP patterns', 'list'),
            record('13-recording', 'Recording', 'film'),
            record('11-staff', 'Staff', 'users'),
        ],
    },
    school: {
        label: 'School admin',
        home: '02-dashboard',
        items: [
            record('02-dashboard', 'Dashboard', 'grid'),
            record('03-sites', 'Sites', 'building'),
            record('04-agents', 'Agents', 'activity'),
            record('06-cameras', 'Cameras', 'camera'),
            record('09-parents', 'Parents', 'users'),
            record('11-assignments', 'Feed access', 'list'),
            record('12-quotas', 'Quotas', 'gauge'),
            record('13-hours', 'Hours', 'clock'),
            record('14-billing', 'Plan & billing', 'card'),
            record('15-audit', 'Audit', 'shield'),
            record('16-recording', 'Recording', 'film'),
        ],
    },
    parent: {
        label: 'Parent',
        home: '02-home',
        items: [
            record('02-home', 'Home', 'home'),
            record('04-grid', 'All cameras', 'grid'),
            record('07-history', 'Usage', 'history'),
            record('09-recordings', 'Recordings', 'film'),
            record('08-account', 'Account', 'user'),
        ],
    },
};
